// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"videoPlayer_videoContainer__1dYG5","customVideoContainer":"videoPlayer_customVideoContainer__9CQRU","videoIframe":"videoPlayer_videoIframe__2hKkj"};